import { useSelector } from "react-redux";
import { utilsState } from "../../../sotre/redux/features/utilsSlice";
import DateInput from "../../../components/common/inputs/DateInput";
import UserModal from "../../../components/common/modals/user-modal/UserModal";
import { useRef, useState } from "react";
import { successMessage } from "../../../utils/toastify-message/ToastifyMessage";

export default function OrdersReportsFilter({ filterDataHandler }) {
  const { utils } = useSelector(utilsState);
  const userModalRef = useRef();

  const [user, setUser] = useState(null);

  const handleUser = (data) => {
    setUser(data.name);
    successMessage(`کاربر ${data?.name} انتخاب شد`);
    filterDataHandler({ page: 1, user: data?._id });
  };

  return (
    <div className="w-full my-6 rounded-xl border border-slate-200 bg-slate-50/80 p-4 md:p-5 dark:border-slate-700 dark:bg-slate-800/50">
      <UserModal ref={userModalRef} handleUser={handleUser} />

      <div className="admin-filter-grid">
        <DateInput
          label={"از تاریخ"}
          onChange={(e) => filterDataHandler({ page: 1, from: e })}
        />
        <DateInput
          label={"تا تاریخ"}
          onChange={(e) => filterDataHandler({ page: 1, to: e })}
        />
        <div className="w-full">
          <label className="block mb-2 text-sm font-medium text-slate-700 dark:text-slate-200">
            نقش
          </label>
          <select
            onChange={(e) => filterDataHandler({ page: 1, role: e.target.value })}
            className="admin-field block w-full"
          >
            <option value={""}>همه</option>;
            {utils?.ROLES_VALUES
              ? utils?.ROLES_VALUES?.map((item) => {
                  return <option value={item?.value}>{item?.name}</option>;
                })
              : null}
          </select>
        </div>
      </div>
    </div>
  );
}
